import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateUnauthenticatedPipe } from '../../filters/translate-unauthenticated.pipe';

@Component({
	standalone: true,
	selector: 'screening-platform',
	templateUrl: './screening-platform.component.html',
	styles: [':host { display: block; }'],
	imports: [TranslateUnauthenticatedPipe]
})
export default class ScreeningPlatformComponent {
	@Output() register = new EventEmitter<void>();
	@Output() login = new EventEmitter<void>();
	@Output() skip = new EventEmitter<void>();
}
